<template>
  <BCard body>
    <div class="d-flex justify-between items-center flex-wrap gap-[16px]">
      <div class="flex items-start">
        <b-button
          variant="primary"
          size="sm"
          class="mr-1 rounded-lg p-0"
          @click="confirmBatalkan()"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <div class="font-semibold text-black text-2xl">
          Ajukan Produk
        </div>
      </div>
      <div class="space-x-4">
        <b-button
          variant="outline-primary"
          class="rounded-lg !flex items-center justify-center gap-[8px]"
          @click="handleAddNewProduct"
        >
          <span class="k-add font-bold" /> Produk Baru
        </b-button>
      </div>
    </div>

    <div class="border mt-[16px] p-[16px] rounded-lg">
      <div class="d-flex flex-row items-center flex-wrap gap-[16px]">
        <div>
          <b-avatar
            :src="detail.image_logo_url"
          />
        </div>
        <div class="d-flex flex-column items-start text-black gap-[4px]">
          <div
            class="font-medium"
            :class="loadingDetail ? 'bg-[#E2E2E2] animate-pulse h-[20.5px] w-[200px] rounded-lg' : ''"
          >
            {{ detail.warehouse_name }}
          </div>
          <div class="">
            <a
              :href="detail.location_link || '#'"
              target="_blank"
              rel="noopener noreferrer"
              class="hover:underline text-[#333333] hover:text-[#08A0F7] flex items-center"
            >
              <span class="k-location mr-[4px]" />
              <span :class="loadingDetail ? 'bg-[#E2E2E2] animate-pulse h-[20.5px] w-[100px] rounded-lg block' : ''">{{ loadingDetail ? '' : detail.location_name || '-' }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-end items-center mt-[16px]">
      <b-input-group class="w-full sm:!w-[300px] input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon" />
        </b-input-group-prepend>
        <b-form-input
          v-model="searchProduct"
          placeholder="Cari nama produk"
          debounce="500"
        />
      </b-input-group>
    </div>
    <div class="mt-1">
      <BTable
        id="table"
        ref="selectableTable"
        :items="fetcherProducts.data"
        :fields="fieldsProducts"
        table-class="min-h-[250px]"
        responsive
        show-empty
      >
        <template #empty>
          <div class="text-center py-3">
            <div
              v-if="isOnLoading"
              ref="loadingFooter"
              class="d-flex justify-content-center align-items-center"
            >
              <b-spinner
                variant="primary"
                label="Loading..."
              />
              <span class="ml-2">Memuat data...</span>
            </div>
            <div
              v-else
              class="text-muted py-2"
            >
              Tidak ada data yang ditampilkan
            </div>
          </div>
        </template>
        <template #cell(checkbox)="data">
          <div class="h-[90px] flex items-center justify-center">
            <BCheckbox
              v-if="data.item.is_bundling === 0"
              v-model="selected"
              :value="data.item.product_id"
              @change="(value) => handleSelectedIndex(data.item, value)"
            />
            <BCheckbox
              v-else
              v-model="selected"
              v-b-tooltip.hover.top="isProductIncomplete(data.item) ? 'Produk satuan penyusun bundling harus dipilih terlebih dahulu' : ''"
              :value="data.item.product_id"
              :disabled="isProductIncomplete(data.item)"
              @change="(value) => handleSelectedIndex(data.item, value)"
            />
          </div>
        </template>
        <template #cell(product_name)="data">
          <div class="d-flex items-center gap-[8px] text-black min-w-[250px] h-[90px]">
            <img
              :src="data.item.images_path ? data.item.images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
              alt="product"
              width="52"
              height="52"
            >
            <div class="">
              <div class="font-medium">
                {{ data.item.product_name }}
              </div>
              <div class="text-primary text-[12px]">
                SKU : {{ data.item.sku }}
              </div>
            </div>
          </div>
        </template>
        <template #cell(product_variants)="{index, item}">
          <VariantList
            :item="item"
            :index="index"
          />
        </template>
        <template #cell(volume)="data">
          <div class="d-flex flex-column min-w-[75px] h-[90px] items-center justify-center">
            <div class="">
              P : {{ data.item.product_length }} cm
            </div>
            <div class="">
              L : {{ data.item.product_width }} cm
            </div>
            <div class="">
              T : {{ data.item.product_height }} cm
            </div>
          </div>
        </template>
        <template #cell(bahan_packing)="data">
          <div class="min-h-[90px] flex items-center justify-center flex-col">
            <PackingList :packings="getProductData(data.item.product_id).packings" />
            <b-button
              :variant="isThisFieldDisabled(data.item.product_id) ? 'outline-secondary' : 'outline-primary'"
              size="sm"
              :disabled="isThisFieldDisabled(data.item.product_id)"
              @click="openPackingSettings(data.item)"
            >
              + Pilih Bahan Packing
            </b-button>
          </div>
        </template>
        <template #cell(product_bonus)="data">
          <div class="h-[90px] flex items-center justify-center">
            <b-form-checkbox
              v-model="getProductData(data.item.product_id).is_product_bonus"
              :disabled="isThisFieldDisabled(data.item.product_id)"
              name="check-button"
              switch
              @input="(value) => handleInputProductBonus(value, data.item)"
            />
          </div>
        </template>
        <template #row-details="data">
          <b-row
            class="pl-[10rem] -mt-[1rem]"
          >
            <b-col cols="12">
              <div class="flex">
                <div
                  v-b-toggle="`bundling-${String(data.index)}`"
                  class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#08A0F7] text-white font-[500] cursor-pointer"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/gift.svg"
                    alt="bundling"
                    width="16"
                  >
                  <div>Bundling {{ data.item.is_bundling_variant ? 'Varian' : '' }}</div>
                </div>
              </div>
              <b-collapse
                :id="`bundling-${String(data.index)}`"
              >
                <div class="border-l-[2px] h-min p-[16px] ml-[3.5rem]">
                  <BundleComponentDetails
                    v-if="data.item.is_bundling_variant"
                    :items="data.item.variant_bundles"
                  />
                  <div
                    v-else
                    class="border rounded-t w-[80%]"
                  >
                    <div class="bg-[#FFECE9] py-[8px] px-[28px] rounded-t text-black font-[500]">
                      Produk
                    </div>
                    <b-table
                      :items="data.item.bundle_component"
                      :fields="fieldsBundling"
                    >
                      <template #cell(no)="row">
                        {{ row.index + 1 }}
                      </template>
                      <template #cell(product_name)="row">
                        <div class="flex gap-[16px] items-start">
                          <img
                            :src="row.item.images_path ? row.item.images_path : 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
                            alt="product"
                            width="52"
                            height="52"
                          >
                          <div class="space-y-[4px]">
                            <div class="font-medium">
                              {{ row.item.product_name }}
                            </div>
                            <div class="text-primary text-[12px]">
                              SKU: {{ row.item.sku }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </b-table>
                  </div>
                </div>
                <div class="flex ml-[0.8rem]">
                  <div
                    v-b-toggle="`bundling-${String(data.index)}`"
                    class="flex items-center gap-[4px] py-[4px] px-[8px] rounded-[12px] !bg-[#F95031] text-white font-[500] cursor-pointer"
                  >
                    <feather-icon
                      icon="ChevronUpIcon"
                    />
                    <div>Tutup</div>
                  </div>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
        </template>
        <template #cell(storage_type)="data">
          <b-form-select
            v-model="getProductData(data.item.product_id).storage_type"
            placeholder="Pilih jenis penyimpanan"
            :disabled="data.item.is_bundling || isThisFieldDisabled(data.item.product_id)"
            :options="mappedStorageType"
          >
            <template #first>
              <b-form-select-option
                :value="null"
                disabled
              >
                Pilih jenis penyimpanan
              </b-form-select-option>
            </template>
          </b-form-select>
        </template>
      </BTable>

      <LoadMoreProducts
        :fetcher="fetcherProducts"
      />

      <div class="bg-white flex flex-wrap gap-[8px] justify-between items-center mt-[16px] sticky bottom-0 z-[10] p-[16px]">
        <p class="text-[14px] text-black mb-0">
          {{ selected.length }} produk dipilih</p>
        <BButton
          class="flex items-center justify-center gap-[8px]"
          :variant="handleDisableTambah ? 'secondary' : 'primary'"
          :disabled="handleDisableTambah || isOnMutateSubmission"
          @click="onFinish"
        >
          <b-spinner
            v-if="isOnMutateSubmission"
            variant="light"
            label="Loading..."
            small
          />
          {{ isOnMutateSubmission ? 'Memproses...' : 'Submit' }}
        </BButton>
      </div>
    </div>
    <b-modal
      id="modal-failed-submission"
      hide-footer
      hide-header
      modal-class="modal-dark"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-img
        role="button"
        style="cursor:pointer"
        class="float-right"
        src="https://storage.googleapis.com/komerce/assets/icons/close-circle.svg"
        @click="closeModal()"
      />
      <b-col
        md="12"
        class="d-flex justify-content-center pt-3"
      >
        <b-img
          width="100"
          src="https://storage.googleapis.com/komerce/assets/elements/transfer-fail.png"
        />
      </b-col>

      <b-col class="text-center mt-2 mb-3">
        <h4>
          Pengajuanmu gagal dikirim.
        </h4>
        <h6 class="text-black">
          <strong>
            Maaf, kamu tidak bisa melakukan pengajuan tambah produk dikarenakan kamu masih memiliki antrian pengajuan yang belum disetujui
          </strong>
        </h6>
      </b-col>
    </b-modal>
    <b-modal
      id="modal-blocking-volumetric"
      hide-footer
      hide-header
      body-class="!py-[36px] !px-[32px]"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div class="flex flex-col space-y-[16px] items-center">
        <div class="text-center text-[24px] font-[600] text-black">
          Lengkapi Data Volumetrik
        </div>
        <div class="text-center text-[16px] text-black">
          Kamu perlu melengkapi data volumetrik berikut agar kamu dapat mendaftarkan produkmu ke gudang Kompack
        </div>
        <b-img
          src="https://storage.googleapis.com/komerce/assets/svg/volumerik-box.svg"
          alt="volumetrik-box"
        />
        <div class="border-[1px] px-[22px] py-[24px] rounded-lg w-full space-y-[16px]">
          <div class="">
            <div class="flex items-center">
              <div class="w-[30%] text-[16px]">
                Panjang
              </div>
              <div class="w-[70%]">
                <b-input-group>
                  <template #append>
                    <b-input-group-text class="!bg-[#E2E2E2]">
                      cm
                    </b-input-group-text>
                  </template>
                  <b-form-input
                    v-model="volumetric.product_length"
                    trim
                    :class="errorLength ? `!bg-[#FFEDED]` : ``"
                    :formatter="formatLength"
                  />
                </b-input-group>
              </div>
            </div>
            <div
              v-if="errorLength"
              class="flex"
            >
              <div class="w-[30%]" />
              <small

                class="text-danger w-[70%]"
              >
                Panjang harus diisi
              </small>
            </div>
          </div>
          <div class="">
            <div class="flex items-center">
              <div class="w-[30%] text-[16px]">
                Lebar
              </div>
              <div class="w-[70%]">
                <b-input-group>
                  <template #append>
                    <b-input-group-text class="!bg-[#E2E2E2]">
                      cm
                    </b-input-group-text>
                  </template>
                  <b-form-input
                    v-model="volumetric.product_width"
                    trim
                    aria-describedby="width-feedback"
                    :class="errorWidth ? `!bg-[#FFEDED]` : ``"
                    :formatter="formatWidth"
                  />
                </b-input-group>
              </div>
            </div>
            <div
              v-if="errorWidth"
              class="flex"
            >
              <div class="w-[30%]" />
              <small

                class="text-danger w-[70%]"
              >
                Lebar harus diisi
              </small>
            </div>
          </div>
          <div class="">
            <div class="flex items-center">
              <div class="w-[30%] text-[16px]">
                Tinggi
              </div>
              <div class="w-[70%]">
                <b-input-group>
                  <template #append>
                    <b-input-group-text class="!bg-[#E2E2E2]">
                      cm
                    </b-input-group-text>
                  </template>
                  <b-form-input
                    v-model="volumetric.product_height"
                    trim
                    aria-describedby="height-feedback"
                    :class="errorHeight ? `!bg-[#FFEDED]` : ``"
                    :formatter="formatHeight"
                  />
                </b-input-group>
              </div>
            </div>
            <div
              v-if="errorHeight"
              class="flex"
            >
              <div class="w-[30%]" />
              <small
                class="text-danger w-[70%]"
              >
                Tinggi harus diisi
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-full mt-[24px] space-x-[12px]">
        <div class="w-[50%]">
          <b-button
            variant="outline-primary"
            class="w-full"
            @click="cancelVolumetric()"
          >
            Batal
          </b-button>
        </div>
        <div class="w-[50%]">
          <b-button
            :variant="disabledSubmitVolumetric() ? 'secondary' : 'primary'"
            class="w-full"
            :disabled="disabledSubmitVolumetric() || isOnMutateVolumetric"
            @click="submitVolumetric()"
          >
            <b-spinner
              v-if="isOnMutateVolumetric"
              variant="light"
              label="Loading..."
              small
            />
            Simpan
          </b-button>
        </div>
      </div>
    </b-modal>
    <ModalMakeItProductBonus
      ref="modalMakeItProductBonus"
      @on-confirm="handleConfirmProductBonus"
    />
    <ModalPackingSettings
      ref="modalPackingSettings"
      :fetcher="fetcherPackingMaterials"
      @on-save="handleSavePackingSettings"
    />
    <ModalAddProduct
      ref="modalAddProduct"
      @product-created="handleNewProductCreated"
    />
    <ModalSuccessSubmission ref="modalSuccessSubmission" />
  </BCard>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import secureLs from '@/libs/secureLs'
import { newAxiosIns } from '@/libs/axios'
import { createPaginatedFetcher } from '@/@core/libs/fetch/usePaginatedFetcher'
import ModalMakeItProductBonus from './ModalMakeItProductBonus.vue'
import ModalPackingSettings from './ModalPackingSettings.vue'
import PackingList from './PackingList.vue'
import ModalAddProduct from './ModalAddProduct.vue'
import VariantList from './VariantList.vue'
import LoadMoreProducts from './LoadMoreProducts.vue'
import ModalSuccessSubmission from './ModalSuccessSubmission.vue'
import { fieldsProducts, fieldsBundling, storageTypeOptions } from './config'
import BundleComponentDetails from './component/BundleComponentDetails.vue'

export default {
  components: {
    ModalMakeItProductBonus,
    ModalPackingSettings,
    PackingList,
    ModalAddProduct,
    VariantList,
    LoadMoreProducts,
    ModalSuccessSubmission,
    BundleComponentDetails,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // eslint-disable-next-line no-param-reassign
      vm.isFromDetailGudang = from.path.startsWith('/detail-gudang-kompack')
    })
  },
  data() {
    return {
      loading: false,
      loadingDetail: true,
      isOnMutateSubmission: false,
      isOnMutateVolumetric: false,
      detail: {},
      products: [],
      selected: [],
      partnerId: secureLs.getItem('userData'),
      searchProduct: '',
      packingOptions: [],
      LabelForm: ['PL', 'KD', 'BW', 'AP'],
      fieldsProducts,
      fieldsBundling,
      wh: this.$route.query.wid,

      limits: 50,
      offset: 0,
      lastData: false,

      volumetric: {},
      errorLength: false,
      errorWidth: false,
      errorHeight: false,

      fetcherPackingMaterials: undefined,
      fetcherProducts: undefined,
      isErrorFetchPackingList: false,
      isLoadingFetchPackingList: true,
      selectedIndex: {},
      bundleIndex: {},
      bundleRelation: {},
      isFromDetailGudang: false,
      storageTypeOptions,
    }
  },

  computed: {
    isOnLoading() {
      return this.fetcherPackingMaterials.isLoading || (this.fetcherProducts.isLoading && this.fetcherProducts.data?.length === 0)
    },
    handleDisableTambah() {
      if (this.selected.length === 0) return true
      if (this.fetcherProducts.data?.length === 0) return true
      if (this.selected.some(productId => !this.selectedIndex[productId]?.storage_type && !this.selectedIndex[productId]?.is_bundling)) return true
      return false
    },
    mappedStorageType() {
      return storageTypeOptions({ is_cold_storage: this.detail.is_cold_storage })
    },
  },

  watch: {
    searchProduct: {
      handler() {
        this.fetcherProducts.fetchData({ reset: true, options: { search: this.searchProduct } })
      },
    },
  },

  created() {
    this.initializeFetcherPackingMaterials()
    this.initializeFetcherProducts()
  },

  async mounted() {
    await this.fetchDetailGudangKompack()
    await this.fetcherPackingMaterials.fetchData({ reset: true })
    await this.fetcherProducts.fetchData({ reset: true })
  },

  methods: {
    async fetchDetailGudangKompack() {
      this.loadingDetail = true
      await this.$http_new.get(`/komship/api/v1/warehouses/${this.$route.params.id}`)
        .then(response => {
          this.detail = response.data.data
          this.loadingDetail = false
        }).catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Gagal',
              icon: 'AlertCircleIcon',
              text: 'Gagal load data, silahkan coba lagi',
              variant: 'danger',
            },
          }, 2000)
        })
    },
    initializeFetcherPackingMaterials() {
      const fnFetch = ({
        offset, limit, search,
      }) => this.$http_new.get(`/komship/api/v1/packing-materials/warehouses/${this.detail.id}`, {
        params: {
          offset,
          limit,
          search,
        },
      }).then(res => {
        const { data } = res.data
        const mappedData = data.map(item => ({
          name: item.name,
          layer: item?.layer,
          packing_id: item.id,
        }))
        return {
          data: mappedData,
        }
      }).catch(error => {
        this.$toast_error({
          message: 'Gagal mengambil data bahan packing, silahkan coba lagi',
        })
        return {
          data: [],
        }
      })

      this.fetcherPackingMaterials = createPaginatedFetcher(fnFetch, 0, 50)
    },
    initializeFetcherProducts() {
      const fnFetch = ({
        offset, limit, search,
      }) => this.$http_new.get('/komship/api/v1/submissions/products', {
        params: {
          warehouse_id: this.wh,
          offset,
          limit,
          search,
        },
      }).then(res => {
        const { data } = res.data
        if (!data) {
          return {
            data: [],
          }
        }
        const mappedData = data?.map(item => {
          this.syncSelectedIndex(item, true, 'register_bundle')
          const isBundlingVariant = item.variant_bundles?.length > 0

          return {
            ...item,
            is_bundling_variant: isBundlingVariant,
            _showDetails: item.is_bundling || isBundlingVariant,
          }
        })
        return {
          data: mappedData,
        }
      }).catch(() => {
        this.$toast_error({
          message: 'Gagal mengambil data produk, silahkan coba lagi',
        })
        return {
          data: [],
        }
      })

      this.fetcherProducts = createPaginatedFetcher(fnFetch, 0, 50)
    },
    handleSelectedIndex(item, value) {
      if (value && this.checkVolumetric(item)) return
      const index = value.findIndex(itemValue => itemValue === item.product_id)
      const prev = this.selectedIndex[item.product_id]
      const storageDefault = !item.storage_type ? (prev?.storage_type ?? 1) : item.storage_type
      this.$set(this.selectedIndex, item.product_id, {
        product_id: item.product_id,
        index,
        selected: index >= 0,
        packings: item.packings || [],
        is_product_bonus: item.is_product_bonus || false,
        incomplete: false,
        storage_type: item.is_bundling ? null : storageDefault,
        is_bundling: item.is_bundling,
      })
      this.syncSelectedIndex(item, index >= 0, 'input')
    },

    syncSelectedIndex(product, checked, type) {
      // Blok 1: Logika untuk produk bundle varian
      const hasVariantBundles = Array.isArray(product.variant_bundles) && product.variant_bundles.length > 0
      if (hasVariantBundles) {
        return product.variant_bundles.forEach(variant => this.handleBundleSelectionChange(variant, type))
      }

      // Blok 2: Logika untuk komponen (produk non-bundle)
      if (!product.is_bundling && type === 'input') {
        return this.handleComponentSelectionChange(product, checked)
      }

      // Blok 3: Logika untuk produk bundle
      return this.handleBundleSelectionChange(product, type)
    },

    /**
     * Menangani perubahan seleksi pada sebuah komponen produk.
     * Ini akan memperbarui semua bundle terkait yang memuat komponen ini.
     */
    handleComponentSelectionChange(product, checked) {
      const relatedBundleIds = this.bundleRelation[product.product_id]
      if (!relatedBundleIds) {
        return true
      }

      const newIncompleteState = !checked

      relatedBundleIds.forEach(bundleId => {
        const bundleState = this.bundleIndex[bundleId]

        if (newIncompleteState) {
          this.deselectProduct(bundleId)
        }

        if (bundleState && newIncompleteState) {
          this.$set(this.bundleIndex, bundleId, {
            components: bundleState.components,
            incomplete: newIncompleteState,
          })
          return
        }

        const bundleIsIncomplete = bundleState.components.some(c => !this.selectedIndex[c]?.selected)

        if (bundleState && !bundleIsIncomplete && bundleState.incomplete !== newIncompleteState) {
          this.$set(this.bundleIndex, bundleId, {
            components: bundleState.components,
            incomplete: newIncompleteState,
          })
        }
      })

      return true
    },

    /**
     * Menangani perubahan/pengecekan status untuk produk bundle.
     */
    handleBundleSelectionChange(product, type) {
      const components = product.bundle_component || []

      if (type === 'register_bundle') {
        this.registerBundleRelations(product.product_id, components)
      }

      const missingComponents = components.reduce((acc, c) => {
        if (!c.is_registered) acc.push(c.product_id)
        return acc
      }, [])

      const missing = missingComponents.some(
        productId => !this.selectedIndex[productId]?.selected,
      )

      this.$set(this.bundleIndex, product.product_id, {
        components: missingComponents,
        incomplete: missing,
      })

      if (missing) {
        this.deselectProduct(product.product_id)
      }

      return missing
    },

    /**
     * Mendaftarkan relasi dari komponen ke bundle.
     */
    registerBundleRelations(bundleId, components) {
      components.forEach(component => {
        const componentId = component.product_id
        if (!this.bundleRelation[componentId]) {
          this.$set(this.bundleRelation, componentId, [bundleId])
        } else if (!this.bundleRelation[componentId].includes(bundleId)) {
          this.bundleRelation[componentId].push(bundleId)
        }
      })
    },

    /**
     * Menghapus produk dari 'selected' dan memperbarui 'selectedIndex'.
     */
    deselectProduct(productId) {
      const productState = this.selectedIndex[productId]

      if (!productState?.selected) {
        return
      }

      const indexToRemove = this.selected.findIndex(item => item === productId)

      if (indexToRemove > -1) {
        this.selected.splice(indexToRemove, 1)
      }

      this.$set(this.selectedIndex, productId, {
        ...productState,
        selected: false,
        incomplete: true,
        index: -1,
      })
    },
    isThisFieldDisabled(id) {
      return !this.selectedIndex[id]?.selected
    },
    handleNewProductCreated(productId) {
      this.fetcherProducts.fetchData({ reset: true })
    },
    openPackingSettings(data) {
      this.$refs.modalPackingSettings.show({
        data,
        position: this.selectedIndex[data.product_id]?.index,
        id: data.product_id,
        packings: this.getProductData(data.product_id).packings,
        totalOrder: 1,
      })
    },
    handleSavePackingSettings({ id, packings }) {
      this.$set(this.selectedIndex[id], 'packings', packings)
    },
    getProductData(id) {
      const cacheOfSelected = this.selectedIndex[id]
      if (!cacheOfSelected) {
        return {
          is_product_bonus: false,
          packings: [],
          storage_type: null,
          id,
        }
      }
      return cacheOfSelected
    },
    handleInputProductBonus(value, item) {
      if (this.isThisFieldDisabled(item.product_id)) return
      if (!value) return
      this.$refs.modalMakeItProductBonus.show({
        index: this.selectedIndex[item.product_id]?.index,
        id: item.product_id,
      })
    },
    handleConfirmProductBonus({ id, indexProductBonus, confirmed }) {
      this.$set(this.selectedIndex[id], 'is_product_bonus', confirmed)
    },
    handleAddNewProduct() {
      this.$refs.modalAddProduct.show()
    },
    async onFinish() {
      this.isOnMutateSubmission = true
      const products = this.selected.map(productId => {
        const currProduct = this.selectedIndex[productId]
        return {
          product_id: currProduct.product_id,
          is_product_bonus: currProduct.is_product_bonus,
          packings: currProduct.packings,
          storage_type: currProduct.storage_type,
        }
      })

      const payload = {
        warehouse_id: Number(this.wh),
        products,
      }

      try {
        await this.$http_new.post('/komship/api/v1/submissions', payload)

        this.$refs.modalSuccessSubmission.show({
          isFromDetailGudang: this.isFromDetailGudang,
          mitraId: this.$route.params.id,
          warehouseId: this.wh,
        })
        this.fetcherProducts.fetchData({ reset: true })
      } catch (error) {
        if (error?.response?.data?.meta?.message.includes('submission already exist')) {
          this.$bvModal.show('modal-failed-submission')
          return
        }
        this.$toast_error({
          message: 'Gagal menambahkan produk, silahkan coba lagi',
        })
      } finally {
        this.isOnMutateSubmission = false
      }
    },
    confirmBatalkan() {
      this.$swal({
        text: 'Kamu yakin ingin membatalkan tambah produk?',
        icon: 'warning',
        iconHtml: '<img src="https://storage.googleapis.com/komerce/core/icon-popup-warning.png">',
        showCancelButton: true,
        cancelButtonText: 'Tidak',
        confirmButtonText: 'Ya',
        customClass: {
          icon: 'border-0 w-50 my-5',
          confirmButton: 'btn btn-outline-primary mr-1 px-5',
          cancelButton: 'btn btn-primary px-4',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$router.go(-1)
        }
      })
    },
    closeModal() {
      this.$router.push({
        path: `/search-gudang/detail/${this.$route.params.id}?wid=${this.wh}`,
      })
    },
    checkVolumetric(data) {
      // Bundle varian dimensinya 0 sesuai kontrak backend, jadi skip validasi volumetric
      if (data?.is_bundling_variant) return false
      if (data) {
        if (
          (data.product_length === null || data.product_length === 0)
  || (data.product_width === null || data.product_width === 0)
  || (data.product_height === null || data.product_height === 0)
        ) {
          this.$bvModal.show('modal-blocking-volumetric')
          this.volumetric = {
            ...data,
            id: data.product_id,
            product_length: (data.product_length === null || data.product_length === 0) ? '' : data.product_length,
            product_width: (data.product_width === null || data.product_width === 0) ? '' : data.product_width,
            product_height: (data.product_height === null || data.product_height === 0) ? '' : data.product_height,
          }
          return true
        }
      }
      return false
    },
    formatLength(value) {
      if (value === '') {
        this.errorLength = true
        return value
      }

      const numericValue = value.replace(/[^0-9]/g, '')

      if (numericValue.length === 0 || numericValue < 1) {
        this.errorLength = true
        return ''
      }
      this.errorLength = false
      // eslint-disable-next-line radix
      return parseInt(numericValue)
    },
    formatWidth(value) {
      if (value === '') {
        this.errorWidth = true
        return value
      }

      const numericValue = value.replace(/[^0-9]/g, '')

      if (numericValue.length === 0 || numericValue < 1) {
        this.errorWidth = true
        return ''
      }
      this.errorWidth = false
      // eslint-disable-next-line radix
      return parseInt(numericValue)
    },
    formatHeight(value) {
      if (value === '') {
        this.errorHeight = true
        return value
      }

      const numericValue = value.replace(/[^0-9]/g, '')

      if (numericValue.length === 0 || numericValue < 1) {
        this.errorHeight = true
        return ''
      }
      this.errorHeight = false
      // eslint-disable-next-line radix
      return parseInt(numericValue)
    },
    cancelVolumetric() {
      this.volumetric = {}
      this.errorLength = false
      this.errorWidth = false
      this.errorHeight = false
      this.selected.pop()
      this.$bvModal.hide('modal-blocking-volumetric')
    },
    disabledSubmitVolumetric() {
      if (this.volumetric.product_length === '' || this.volumetric.product_width === '' || this.volumetric.product_height === '') return true
      return false
    },
    submitVolumetric() {
      this.isOnMutateVolumetric = true
      newAxiosIns.put(`/komship/api/v1/product-warehouses/products/${this.volumetric.id}/dimensions`, {
        height: parseInt(this.volumetric.product_height, 0),
        length: parseInt(this.volumetric.product_length, 0),
        width: parseInt(this.volumetric.product_width, 0),
      }).then(() => {
        this.$bvModal.hide('modal-blocking-volumetric')
        this.handleSelectedIndex(this.volumetric, this.selected)
        this.volumetric = {}
        this.errorLength = false
        this.errorWidth = false
        this.errorHeight = false
        this.fetcherProducts.fetchData({ reset: true })
      }).catch(error => {
        this.$bvModal.hide('modal-blocking-volumetric')
        this.volumetric = {}
        this.errorLength = false
        this.errorWidth = false
        this.errorHeight = false
        this.selected.pop()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Gagal',
            icon: 'AlertCircleIcon',
            text: 'Gagal update data, silahkan coba lagi',
            variant: 'danger',
          },
        }, 2000)
      })
        .finally(() => {
          this.isOnMutateVolumetric = false
        })
    },
    isProductIncomplete(product) {
      return this.bundleIndex[product.product_id]?.incomplete
    },
  },
}
</script>

<style lang="scss">
@import '@/@core/scss/vue/libs/vue-select.scss';
</style>

<style scoped>
 .status-tersedia {
  background-color: #DCF3EB;
  padding: 5px 10px;
  border-radius: 4px;
  color: #34A770;
 }
 .image-product{
  object-fit: cover;
  object-position: center center;
  width: 50px!important;
  height: 50px!important;
}
 .status-penuh {
  background-color: #FFEDED;
  padding: 5px 10px;
  border-radius: 4px;
  color: #E31A1A;
 }
</style>
